/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * HẠN SỬ DỤNG CỦA MỘT KẾT LUẬN — YC-35, và TẦNG 3 của YC-36.
 *
 * Bệnh đã lộ ra ở ba tầng, cùng một hình:
 *
 *   1 · đường dữ liệu   `MeterData` giữ mẫu cuối          → `soDoConDung()`
 *   2 · bộ nhớ đệm      không nhịp lấy lại ⇒ kết luận ghim → `hanConLaiMs`
 *   3 · KẾT XUẤT        không nhịp vẽ lại ⇒ pixel ghim     → tệp này
 *
 * dev_device chốt luật: *"Bệnh không nằm ở tầng nào cả — nó nằm ở chỗ không tầng nào có
 * nghĩa vụ tự già đi."* Nên tầng 3 phải mang nghĩa vụ ấy một cách CÓ CẤU TẠO, không dựa vào
 * việc một cái `setInterval` may mắn được chạy.
 *
 * ─────────────────────────────────────────────────────────────────────────────────────
 * 🔴 HAI ĐỒNG HỒ, LẤY CÁI LỚN HƠN — và đây là câu trả lời cho câu (b) dev_device hỏi
 *   *("máy ngủ 3 tiếng rồi quay lại: `performance.now()` có nhảy lên không, hay nó DỪNG?")*.
 *
 * ⚠ TÔI KHÔNG BIẾT, VÀ TÔI KHÔNG ĐOÁN. Nó khác nhau theo trình duyệt và hệ điều hành
 *   (`CLOCK_MONOTONIC` không tính thời gian treo máy, `CLOCK_BOOTTIME` có), và tôi đã thử đo
 *   hai lần trong sandbox — **cả hai lần đều hỏng DỤNG CỤ**, không phải hỏng giả thuyết:
 *   `bringToFront()` trong headless không làm trang kia ẩn, và `Page.setWebLifecycleState`
 *   nhận lệnh nhưng `visibilityState` vẫn "visible". Container không treo máy được.
 *
 * ⇒ Nên tôi không xây trên một câu trả lời tôi chưa có. Lấy **số LỚN HƠN của hai hiệu số**:
 *
 *     đồng hồ ĐƠN ĐIỆU (`performance.now`)  — không lùi khi người dùng chỉnh giờ
 *     đồng hồ TƯỜNG    (`Date.now`)         — có tính thời gian máy ngủ
 *
 *   · máy ngủ 3 tiếng, đơn điệu DỪNG  ⇒ đồng hồ tường bắt được  ⇒ hết hạn. ĐÚNG.
 *   · máy ngủ 3 tiếng, đơn điệu CHẠY  ⇒ chính nó bắt được       ⇒ hết hạn. ĐÚNG.
 *   · người dùng vặn giờ LÙI 3 tiếng  ⇒ tường ra số âm, bị bỏ    ⇒ không trẻ lại. ĐÚNG.
 *   · người dùng vặn giờ TIẾN 3 tiếng ⇒ hết hạn sớm              ⇒ SAI, nhưng sai về phía
 *     GIẤU số liệu và bảo người ta bấm đọc lại. Chiều sai chấp nhận được.
 *
 * 📌 Cả bốn ca đều đúng chiều **mà không cần biết câu trả lời của (b)**. Đó là cách duy nhất
 *   tôi thấy để không phải đoán: đừng chọn đồng hồ, hãy để hai đồng hồ canh nhau.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */

/**
 * Thời gian THẬT đã trôi kể từ mốc — lấy số lớn hơn của hai hiệu số (xem trên).
 * ⛔ Kẹp sàn về 0: cả hai cùng âm là chuyện của một đồng hồ hỏng, không phải "chưa trôi gì".
 */
export function troiThucSu(dDonDieuMs: number, dTuongMs: number): number {
  const a = Number.isFinite(dDonDieuMs) ? dDonDieuMs : 0;
  const b = Number.isFinite(dTuongMs) ? dTuongMs : 0;
  return Math.max(0, a, b);
}

/**
 * Kết luận này còn trong hạn không.
 * `undefined` / `null` = máy chủ đời cũ chưa gửi hạn ⇒ CHƯA BIẾT ⇒ không vẽ (L62).
 */
export function conTrongHan(hanConLaiMs: number | undefined | null, daTroiMs: number): boolean {
  if (typeof hanConLaiMs !== 'number' || !Number.isFinite(hanConLaiMs)) return false;
  return daTroiMs < hanConLaiMs;
}

/** Câu nói ra khi một kết luận đã hết hạn ngay trên màn hình, không phải lúc nhận. */
/*
 * 🔴 09/10/2026 — RÚT CÒN BỐN CHỮ (lee khoanh đỏ ô này trên H3).
 *   Câu cũ ("Số liệu trên màn hình đã quá hạn — tủ chưa gửi gì mới kể từ lần đọc trước") nói
 *   ĐÚNG nhưng nói bằng giọng người viết app: nó giải thích cơ chế hết hạn. Tiêu đề thẻ đã là
 *   "Chưa có số liệu" rồi, nên câu này chỉ còn một việc: cho biết LÝ DO là tủ chưa gửi.
 */
export const CAU_HET_HAN = 'Tủ chưa gửi số mới.';
